import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { ConferenceViewModelWithDetails, PageElementType, SponsorshipProductAddOnViewModel, SponsorshipProductViewModel } from 'src/app/_models/generatedModels';
import { CallForSponsorsService, ConferenceCMSService, OrganizationService } from 'src/app/_services/generatedServices';
import { SponsorshipCartService } from 'src/app/_services/sponsorship-cart.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { BoothPickerComponent } from './booth-picker.component';
import { A } from "@angular/cdk/keycodes";

@Component({
  selector: 'bxl-view-product',
  templateUrl: 'view-product.component.html',
})
export class ViewProductComponent implements OnInit {
  initialized = false;
  productId: number;
  conferenceId: string;
  selectedAddOns: SponsorshipProductAddOnViewModel[];
  product: SponsorshipProductViewModel;
  @ViewChild('dataContainer') dataContainer: ElementRef;
  homeRoute: string;
  conference: ConferenceViewModelWithDetails;
  subProducts: SponsorshipProductViewModel[];

  constructor(private route: ActivatedRoute, private router: Router, private cmsService: ConferenceCMSService, private toaster: ToasterService, private modalService: NgbModal, private callForSponsorService: CallForSponsorsService, public orgService: OrganizationService, public cart: SponsorshipCartService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.productId = +params.get('productId');
      this.conferenceId = params.get('conferenceSlug');

      this.cmsService.getWebsitePagesForConference(this.conferenceId).subscribe((pages) => {
        var page = Enumerable.from(pages)
          .where((x) => x.elements.find((x) => x.pageElementType.toString() == 'ProductListing') != null)
          .firstOrDefault();
        this.homeRoute = page.slug;

        this.orgService.getConferenceBySlug(this.conferenceId).subscribe((conference) => {
          this.callForSponsorService.getSingleProduct(this.conferenceId, this.productId).subscribe((result) => {
            this.callForSponsorService.getSubProductsForProduct(this.conferenceId, this.productId).subscribe((subproducts) => {
              this.product = result;
              this.subProducts = subproducts;
              this.conference = conference;
              this.selectedAddOns = [].constructor(result.addOnQuantity);
              this.initialized = true;
            });
          });
        });
      });
    });
  }

  pickLocation() {
    console.log(this.conferenceId);
    const modalRef = this.modalService.open(BoothPickerComponent, {
      size: 'lg',
      windowClass: 'fullscreen',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.product = this.product;
    modalRef.componentInstance.boothIdsFromCart = Enumerable.from(this.cart.items)
      .where((x) => x.product.isBooth && x.product.id == this.product.id)
      .select((x) => x.variationId)
      .toArray();

    modalRef.result.then(
      (result) => {
        Enumerable.from(this.subProducts).where(x => x.selected).forEach((subProduct) => {
          this.cart.addItem(subProduct, null, null, 1, null);
        });
        this.router.navigate(['cart'], {relativeTo: this.route.parent});
      },
      (reason) => {}
    );
  }

  addToCart() {
    if (Enumerable.from(this.selectedAddOns).count((x) => x != null) < this.product.addOnQuantity) {
      this.toaster.messageDialog('Please choose ' + this.product.addOnQuantity + ' add-ons.', 'Add-ons Required').subscribe();
      return;
    }

    var groups = Enumerable.from(this.selectedAddOns).groupBy(
      (x) => x,
      (x) => x
    );

    var error = false;
    groups.forEach((group) => {
      console.log(group.key());
      console.log(group.count());
      console.log(group.key().remainingQuantity);
      if (group.count() > group.key().remainingQuantity) {
        this.toaster.messageDialog('The add-on combinations you chose exceeds the maximum quantity for those add-ons.', 'Add-On Quantity Exceeded').subscribe();
        error = true;
      }
    });

    if (error) {
      return;
    }

    Enumerable.from(this.subProducts).where(x => x.selected).forEach((subProduct) => {
      this.cart.addItem(subProduct, null, null, 1, null);
    });

    this.cart.addItem(this.product, null, null, 1, this.selectedAddOns);
    this.router.navigate(['cart'], {relativeTo: this.route.parent});
  }

  protected readonly A = A;
}
